<template>
  <h6 class="margin-top-s margin-bottom-s weight" :class="{ 'mcom-desktop-transform': isMcom }">
    {{ title }}
  </h6>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
});

const envProps = useEnvProps();
const isMcom = envProps.isMcom;
</script>

<style lang="scss">
.weight {
  font-weight: 500;
}
</style>

<style lang="scss" brand="mcom">
.mcom-desktop-transform {
  @media only screen and (min-width: 1024px) {
    text-transform: lowercase;

    &::first-letter {
      text-transform: uppercase;
    }
  }
}
</style>
